const state = {
  tableData: {},
  exportFileName: 'report.csv',
  // eslint-disable-next-line no-unused-vars
  defaultSortFunction: (a, b) => 0
};

const getters = {
  tableData(state) {
    return state.tableData;
  },
  exportFileName(state) {
    return state.exportFileName;
  },
  defaultSortFunction(state) {
    return state.defaultSortFunction;
  }
};

const mutations = {
  setTableData(state, data) {
    state.tableData = data;
    // eslint-disable-next-line no-unused-vars
    state.defaultSortFunction = (a, b) => 0;
  },
  setExportFileName(state, data) {
    state.exportFileName = data;
  },
  setDefaultSortFunction(state, data) {
    state.defaultSortFunction = data;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/blade/data-table-view.js